import React from 'react';
import { useIntl } from 'react-intl-next';
import { Text } from '@atlaskit/primitives';
import { IntlQuestionTypeMessages } from '../../../../jira-common';
import { questionTypeToQuestionTypeMessage } from '../../../utils';
import { messages } from './messages';
import { UnknownQuestionTypeText } from './styled';
export function UnknownQuestionType({
  questionType
}) {
  const intl = useIntl();
  const questionTypeMessage = IntlQuestionTypeMessages[questionTypeToQuestionTypeMessage(questionType)];
  return /*#__PURE__*/React.createElement(UnknownQuestionTypeText, {
    "data-testid": "proforma-unknown-question"
  }, intl.formatMessage(messages.unknownQuestionType, {
    questionType: questionTypeMessage ? intl.formatMessage(questionTypeMessage) : '',
    // Cannot rely on ProformaIntlProvider for this since this could be rendered inside the editor (which prevents accesses from providers outside)
    strong: chunks => /*#__PURE__*/React.createElement(Text, {
      as: "strong"
    }, chunks)
  }));
}